import React from 'react'
import { autorun } from 'mobx'
import useModel from './use-model'
import { getMapValue } from '@morningtrain/react-helpers'

export default function useModelValue (name = '', defaultValue = null) {
  const model = useModel()

  const [value, setValue] = React.useState(getMapValue(model, name, defaultValue))
  const valueRef = React.useRef(value)

  React.useEffect(() => {
    const disposer = autorun(() => {
      const currentValue = getMapValue(model, name, defaultValue)

      if (currentValue !== valueRef.current) {
        valueRef.current = currentValue
        setValue(currentValue)
      }
    }, { fireImmediately: true })

    return () => {
      disposer()
    }
  }, [model, name, defaultValue])

  return value
}
